import React from "react";
import styled from "styled-components";

const ResumeButton1 = ({ text, theme = "dark" }) => {
  return (
    <StyledWrapper theme={theme}>
      <button className="animated-button">
        <Arrow className="arr-2" />
        <span className="text">{text}</span>
        <span className="circle" />
        <Arrow className="arr-1" />
      </button>
    </StyledWrapper>
  );
};

const Arrow = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24">
  <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" fill="black" />
</svg>

);

const StyledWrapper = styled.div`
  .animated-button {
    position: relative;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 14px 36px;
    border: 2px solid black;
    font-size: 16px;
    background-color: dark;
    border-radius: 100px;
    font-weight: 600;
    color:dark;
    box-shadow: 0 0 0 2px white;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .animated-button svg {
    position: absolute;
    width: 24px;
    fill:white;
    color: black;
    z-index: 9;
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .arr-1 {
    right: 16px;
    color: black;
  }

  .arr-2 {
    left: -25%;
        color: black;

  }

  .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    background-color:white;
    border-radius: 50%;
    opacity: 0;
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .text {
    position: relative;
    z-index: 1;
    transform: translateX(-12px);
    transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  }

  .animated-button:hover {
    box-shadow: 0 0 0 12px transparent;
    background-color: transparent;
    color: black;
    border-radius: 12px;
  }

  .animated-button:hover .arr-1 {
    right: -25%;
    color :black;
  }

  .animated-button:hover .arr-2 {
    left: 16px;
        color :black;

  }


  .animated-button:hover .text {
    transform: translateX(12px);
  }

  .animated-button:hover svg {
    fill:#212121;
  }

  .animated-button:active {
    transform: scale(0.95);
    box-shadow: 0 0 0 4px white;
  }

  .animated-button:hover .circle {
    width: 220px;
    height: 220px;
    opacity: 1;
  }
    
  /* Responsive styles */
  @media (max-width: 768px) {
    .animated-button {
      padding: 8px 28px;
      font-size: 14px;
    }

    .animated-button svg {
      width: 20px;
    }

    .animated-button:hover .circle {
      width: 180px;
      height: 180px;
    }
  }

  @media (max-width: 480px) {
    .animated-button {
      padding: 10px 24px;
      font-size: 12px;
    }

    .animated-button svg {
      width: 18px;
    }

    .animated-button:hover .circle {
      width: 150px;
      height: 150px;
    }
  }
`;

export default ResumeButton1;
